var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"dashboard-container"},[(_vm.loading)?_c('v-container',{attrs:{"className":"text-center"}},[_c('v-progress-circular',{attrs:{"indeterminate":"","color":"primary"}})],1):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }